<template>
  <div>
    <v-navigation-drawer v-model="$store.state.drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <template>
          <div v-for="item in items" :key="item.name">
            <v-list-group
              v-if="item.children"
              :key="item.name"
              v-model="item.model"
              :prepend-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
              append-icon
            >
            
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <div v-for="(child, i) in item.children" :key="i">
                <router-link
                  class="sidebar-link"
                  :to="{ name: child.link}">
                  <v-list-item class="sidebar-link-item">
                    <!--<v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
                    </v-list-item-action>-->
                    <v-list-item-content >
                      <v-list-item-title style="margin-left: 70px;"><v-icon>{{child.icon}} </v-icon> {{ child.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
              </div>
            </v-list-group>
            <v-divider></v-divider>
          </div>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
          {
            name:"User",
            model:false,
            children:[
                {
                    name:"Parent/Student Bypass Login",
                    icon:"mdi-account-key",
                    link:'mngt-by-pass'
                },
                {
                    name:"Faculty Bypass Login",
                    icon:"mdi-account-key",
                    link:'mngt-faculty-by-pass'
                },
                {
                    name:"Change Password",
                    icon:"mdi-key-change",
                    link:'update-password'
                },
               
            ]
          },
            {
            name:"Time Table",
            model:false,
            children:[
                {
                    name:"Division Time Table",
                    icon:"mdi-calendar-clock",
                    link:'mngt-div-time-table'
                },
                {
                    name:"Faculty Time Table",
                    icon:"mdi-calendar-check",
                    link:'mngt-faculty-time-table'
                },
               
            ]
          },
          {
            name:"Academics",
            model:false,
            children:[
                {
                    name:"Academics Dashboard",
                    icon:"mdi-chart-bar",
                    link:'mngt-academics-dashboard-report'
                },
                {
                    name:"Attendance Report",
                    icon:"mdi-account-check",
                    link:'mngt-attendance-report'
                },
                {
                    name:"Admitted Student Report",
                    icon:"mdi-account-multiple",
                    link:'mngt-user-report'
                },
                //  {
                //     name:"Pre - Primary Report Card",
                //     icon:"mdi-account-multiple",
                //     link:'mngt-student-report-pre-primary-card'
                // },
                //  {
                //     name:"Primary / Secondary Report Card",
                //     icon:"mdi-account-multiple",
                //     link:'mngt-student-report-primary-card'
                // },
                {
                    name:"Management Instructor Report",
                    icon:"mdi-account-multiple",
                    link:'mngt-inst-report'
                },
                {
                    name:"Management Instructor Structure Report",
                    icon:"mdi-account-multiple",
                    link:'mngt-inst-structure-report'
                },
               
            ]
          },    
          {
            name:"Accounting And Fees",
            model:false,
            children:[
                {
                    name:"Payment Daily Transaction Report",
                    icon:"mdi-calendar-check",
                    link:'mngt-payment-daily-transaction-report'
                },
            ]
          },      
          // {
          //   name:"Leave Management",
          //   model:false,
          //   children:[
          //       {
          //           name:"Employee Leave Balance Report",
          //           icon:" mdi-account-multiple",
          //           link:'mngt-emp-leave-balnace-report'
          //       },
          //   ]
          // },      
      ]
    };
  },
  methods: {},
  mounted() {
    
  }
};
</script>
<style scoped>
.sidebar-link {
  text-decoration: none;
}
.sidebar-link-item:hover {
  background-color: rgb(202, 206, 209) !important;
}

</style>